import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/**
 * @file 工具栏
 * @author alfielv
 */
import _ from 'lodash';
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { Button, Icon } from '@tencent/spaui';
import { PREFIX_CLS } from '../../constants';
import BizIcon from '../Icon';
import './index.css';
var prefixCls = "".concat(PREFIX_CLS, "-toolbar"); // 【必须】中文注释必填，从而在ArgsTable中显示，触发文档构建

// 【必须】必须如此定义才能触发storybook ArgsTable，不能直接export default props => {}
var Toolbar = function Toolbar(props) {
  var type = props.type,
      className = props.className,
      left = props.left,
      leftFixer = props.leftFixer,
      right = props.right,
      leftClassName = props.leftClassName,
      rightClassName = props.rightClassName,
      clear = props.clear,
      onClose = props.onClose; // 获取有效React节点

  var getValidReactChild = useCallback(function (content) {
    if (_.isObject(content)) {
      return !_.isEmpty(content) && content;
    }

    return content;
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(prefixCls, {
      'has-right-toolbar': right
    }, _defineProperty({}, "".concat(prefixCls, "--mass"), type === 'mass'), className)
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames("".concat(prefixCls, "__left"), leftClassName)
  }, !!leftFixer && /*#__PURE__*/React.createElement(React.Fragment, null, getValidReactChild(leftFixer), /*#__PURE__*/React.createElement(BizIcon, {
    type: "divider"
  })), getValidReactChild(left)), /*#__PURE__*/React.createElement("div", {
    className: classnames("".concat(prefixCls, "__right"), rightClassName)
  }, getValidReactChild(right), clear && /*#__PURE__*/React.createElement(Button, {
    displayType: "link",
    className: "borderless button-toolbar-close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))));
}; // 【必须】必须定义defaultProps，触发storybook ArgsTable 默认值


Toolbar.defaultProps = {
  type: 'default',
  clear: false
};
export default Toolbar;